"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToDecimalPlaces = void 0;
/**
 * A function to round a number to a given number of decimal places. Returns a string xor a number, depending on calculation
 *
 * e.g.
 *
 * roundToDecimalPlaces(453.592)      // 453.6
 *
 * roundToDecimalPlaces(453.592, 1)   // 453.6
 *
 * roundToDecimalPlaces(453.592, 2)   // 453.59
 *
 * roundToDecimalPlaces(453.592, -1)  // 450
 *
 * roundToDecimalPlaces(453.598, 2, true)  // 453.60
 *
 * @param {Number} num the number to be rounded
 * @param {Number} numDecimalPlaces (defaults to 1) the number of decimal places (can be negative to round to nearest ten, hundred, etc)
 * @param {Boolean} keepTrailingZeroes (defaults to false) will return a string with trailing zeroes when necessary if desired
 */
const roundToDecimalPlaces = (num, numDecimalPlaces = 1, keepTrailingZeroes) => {
    if (!num && num !== 0)
        return null;
    const numDecimalsToUse = Math.round(numDecimalPlaces);
    const roundedValue = Math.round(num * Math.pow(10, numDecimalsToUse)) / Math.pow(10, numDecimalsToUse);
    if (isNaN(roundedValue))
        return null;
    if (!!keepTrailingZeroes)
        return Number(roundedValue).toFixed(numDecimalsToUse);
    return roundedValue;
};
exports.roundToDecimalPlaces = roundToDecimalPlaces;
//# sourceMappingURL=roundToDecimalPlaces.js.map